import { render, staticRenderFns } from "./StdRisk.vue?vue&type=template&id=11e2427a&"
import script from "./StdRisk.vue?vue&type=script&lang=js&"
export * from "./StdRisk.vue?vue&type=script&lang=js&"
import style0 from "./StdRisk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdRisk.vue"
export default component.exports